"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Online Training API
 * Online Training API documentation
 *
 * The version of the OpenAPI document: 0.0.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./api/account-api"), exports);
__exportStar(require("./api/account-resource-api"), exports);
__exportStar(require("./api/activity-resource-api"), exports);
__exportStar(require("./api/administrator-administration-api"), exports);
__exportStar(require("./api/advertise-api"), exports);
__exportStar(require("./api/advertise-administration-api"), exports);
__exportStar(require("./api/advertise-resource-api"), exports);
__exportStar(require("./api/agora-room-nfo-resource-api"), exports);
__exportStar(require("./api/ap-package-course-payments-resource-api"), exports);
__exportStar(require("./api/ap-subscription-resource-api"), exports);
__exportStar(require("./api/app-info-api"), exports);
__exportStar(require("./api/app-info-administration-api"), exports);
__exportStar(require("./api/app-nfo-resource-api"), exports);
__exportStar(require("./api/broadcast-program-api"), exports);
__exportStar(require("./api/broadcast-program-administration-api"), exports);
__exportStar(require("./api/broadcast-program-resource-api"), exports);
__exportStar(require("./api/carousel-api"), exports);
__exportStar(require("./api/carousel-administration-api"), exports);
__exportStar(require("./api/carousel-mage-resource-api"), exports);
__exportStar(require("./api/chat-api"), exports);
__exportStar(require("./api/complaint-resource-api"), exports);
__exportStar(require("./api/customer-administration-api"), exports);
__exportStar(require("./api/customer-metadata-resource-api"), exports);
__exportStar(require("./api/customer-service-api"), exports);
__exportStar(require("./api/customer-service-administration-api"), exports);
__exportStar(require("./api/fitness-target-resource-api"), exports);
__exportStar(require("./api/global-notification-resource-api"), exports);
__exportStar(require("./api/hear-from-resource-api"), exports);
__exportStar(require("./api/help-request-resource-api"), exports);
__exportStar(require("./api/legal-document-api"), exports);
__exportStar(require("./api/legal-document-administration-api"), exports);
__exportStar(require("./api/legal-document-resource-api"), exports);
__exportStar(require("./api/live-api"), exports);
__exportStar(require("./api/live-room-action-resource-api"), exports);
__exportStar(require("./api/notification-api"), exports);
__exportStar(require("./api/notification-administration-api"), exports);
__exportStar(require("./api/notification-resource-api"), exports);
__exportStar(require("./api/onesignal-api"), exports);
__exportStar(require("./api/onesignal-dof-user-account-resource-api"), exports);
__exportStar(require("./api/package-course-api"), exports);
__exportStar(require("./api/package-course-administration-api"), exports);
__exportStar(require("./api/package-course-resource-api"), exports);
__exportStar(require("./api/package-course-training-resource-api"), exports);
__exportStar(require("./api/package-course-training-set-resource-api"), exports);
__exportStar(require("./api/package-course-training-watch-resource-api"), exports);
__exportStar(require("./api/payment-log-resource-api"), exports);
__exportStar(require("./api/payment-resource-api"), exports);
__exportStar(require("./api/personal-trainer-api"), exports);
__exportStar(require("./api/personal-trainer-administration-api"), exports);
__exportStar(require("./api/personal-trainer-earnings-resource-api"), exports);
__exportStar(require("./api/personal-trainer-metadata-resource-api"), exports);
__exportStar(require("./api/personal-trainer-rate-resource-api"), exports);
__exportStar(require("./api/public-user-resource-api"), exports);
__exportStar(require("./api/subscription-log-resource-api"), exports);
__exportStar(require("./api/subscription-plan-api"), exports);
__exportStar(require("./api/subscription-plan-administration-api"), exports);
__exportStar(require("./api/subscription-plan-resource-api"), exports);
__exportStar(require("./api/system-api"), exports);
__exportStar(require("./api/user-account-resource-api"), exports);
__exportStar(require("./api/user-jwt-controller-api"), exports);
__exportStar(require("./api/user-package-course-resource-api"), exports);
__exportStar(require("./api/user-resource-api"), exports);
__exportStar(require("./api/user-statistics-resource-api"), exports);
__exportStar(require("./api/user-statistics-total-resource-api"), exports);
__exportStar(require("./api/user-subscription-resource-api"), exports);
